import { Text } from "@ui-kitten/components";
import React from "react";
import { Pressable, View } from "react-native";
import { LINE, PAPER } from "../helpers";

interface Props {
  pathLabel: string;
  isLoggedIn: boolean;
  username?: string;
  primaryColor: string;
  onSignIn: () => void;
  onSignOut: () => void;
}

// Persistent session bar (prototype's home footer): selected path on the
// left; sign-in entry or the signed-in identity on the right.
const SessionBarV3 = ({
  pathLabel,
  isLoggedIn,
  username,
  primaryColor,
  onSignIn,
  onSignOut,
}: Props) => (
  <View
    testID="v3-session-bar"
    className="flex-row items-center justify-between px-5 py-5"
    style={{
      minHeight: 84,
      backgroundColor: PAPER,
      borderTopWidth: 1,
      borderTopColor: LINE,
    }}
  >
    <View className="flex-1 pr-3">
      <Text category="c1" appearance="hint">
        Selected path
      </Text>
      <Text category="s1" numberOfLines={1}>
        {pathLabel}
      </Text>
    </View>
    {isLoggedIn ? (
      <View className="items-end">
        <Text category="c1" appearance="hint" numberOfLines={1}>
          {username ?? "Signed in"}
        </Text>
        <Pressable testID="v3-sign-out" onPress={onSignOut}>
          <Text category="s2" style={{ color: primaryColor }}>
            Sign out
          </Text>
        </Pressable>
      </View>
    ) : (
      <Pressable
        testID="v3-member-login"
        accessibilityRole="button"
        onPress={onSignIn}
        style={{
          borderWidth: 2,
          borderColor: primaryColor,
          borderRadius: 999,
          paddingHorizontal: 14,
          paddingVertical: 8,
        }}
      >
        <Text category="s2" style={{ color: primaryColor }}>
          Already a member?
        </Text>
      </Pressable>
    )}
  </View>
);

export default SessionBarV3;
